module.exports = __webpack_public_path__ + "img/saul.cc72326e.png";